export default {
  home: 'Главная',
  developers: 'Застройщики',
  agencies: 'Агентства',
  properties: 'Объекты',
  login: 'Войти',
  registration: 'Регистрация'
}